webpackJsonp([49605662093542],{

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'initialize'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'initialize()'
	      ),
	      ' method is called at the end of model instantiation, and is useful for storing data that other methods will need.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      initialize: function(attributes, options) {\n        // does nothing\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A common use for this method is storing variables that will be needed to construct nested URLs.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Many REST API endpoints have flat URLs, like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/tweets'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/users'
	      ),
	      '. But some APIs require you to use a nested URL structure like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/users/1/tweets/1'
	      ),
	      ' when fetching or updating data.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The code below shows how you can use ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'initialize()'
	      ),
	      ' to accomplish this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        urlRoot: \'http://localhost:1337\',\n\n        initialize: function(attributes, options){\n          this.user = options.user;\n        },\n\n        url: function() {\n          return `${this.urlRoot}/users/${this.user}/tweets/${this.attributes.id}`\n        }\n      })\n\n      const tweet = new Tweet({\n        id: 1\n      }, {\n        user: 1\n      })\n\n      tweet.fetch()\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'re providing a second argument to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'new Tweet()'
	      ),
	      ', and that additional information is passed to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'initialize()'
	      ),
	      ' as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'options'
	      ),
	      ', where we save the id for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then we override the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'url()'
	      ),
	      ' function to compose the final nested URL using the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      ', along with the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' of the tweet.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When we call ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.fetch()'
	      ),
	      ' it will make an API call to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/users/1/tweets/1'
	      ),
	      ', and you can confirm the url it will use by calling ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.url()'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-initialize-js-c61e46ace04b88e5cd15.js